<script lang="ts">
export default { name: 'CommonRadio', inheritAttrs: false }
</script>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps(['modelValue', 'value', 'label', 'id', 'disabled', 'inlieBlock'])
const emit = defineEmits(['update:modelValue'])

/** チェックされているか否か */
const checked = computed(() => {
  return props.modelValue === props.value
})

/** changeイベント発火時の処理 */
function onChange(e: Event) {
  const checked = (e.target as HTMLInputElement).checked
  // チェックされたら値を更新
  checked && emit('update:modelValue', props.value)
}
</script>

<template>
  <span v-bind="$attrs">
    <input
      type="radio"
      :id="id"
      :value="value"
      :checked="checked"
      :disabled="disabled"
      @change="onChange"
      :class="inlieBlock ? 'inline-block opacity-0' : ' hidden'"
    />
    <label
      :for="id"
      :class="{ 'text-gray-500': disabled, 'inline-block': inlieBlock }"
      class="sm:py-[12px] sm:pl-[12px] py-[10px] pl-[10px] w-full ml-3 cursor-pointer radio-label-btn not-next-to-checked:before:border-bray-300 next-to-checked:before:border-orange before:border before:border-solid"
      >{{ label }}</label
    >
  </span>
</template>
<style scoped tailwind>
.radio-label-btn {
  @apply relative;
}
.radio-label-btn::before {
  background: #fff;
  border-radius: 50%;
  content: '';
  display: block;
  height: 20px;
  left: -14px;
  margin-top: -8px;
  border-color: #a8a8aa;
  position: absolute;
  top: 50%;
  width: 20px;
}
.radio-label-btn::after {
  background: #f45912;
  border-radius: 50%;
  content: '';
  display: block;
  height: 12px;
  left: -10px;
  margin-top: -4px;
  opacity: 0;
  position: absolute;
  top: 50%;
  width: 12px;
}
input[type='radio']:checked + .radio-label-btn::after {
  opacity: 1;
}
input[type='radio'] {
  position: relative;
  top: 2px;
}
</style>
